import { printStackTrace18lnx7a39cni as printStackTrace } from '../../../../../kotlin-kotlin-stdlib/kotlin/throwableExtensions.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  SetLens2527bvop19mpo as SetLens,
  ModifyLens104zsbx7gwa6e as ModifyLens,
  SetValueLensuxj8ukufftbv as SetValueLens,
  ModifyValueLenspp00mwqm1elc as ModifyValueLens,
} from '../lensing/abstracts.mjs';
import { _ReactiveState___init__impl__fvdp9b3rxdz1mjh763m as _ReactiveState___init__impl__fvdp9b } from './ReactiveState.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function Reactive$Companion$reportException$lambda(it) {
  printStackTrace(it);
  return Unit_instance;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        tmp.reportException_1 = Reactive$Companion$reportException$lambda;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var ReactiveClass;
function Reactive() {
  if (ReactiveClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Reactive', VOID, VOID, [Listenable()]);
    ReactiveClass = $;
  }
  return ReactiveClass;
}
function lens(get, set) {
  return SetLens().new_com_lightningkite_reactive_lensing_SetLens_rp2o22_k$(this, get, set);
}
function lens_0(get, modify) {
  return ModifyLens().new_com_lightningkite_reactive_lensing_ModifyLens_a6lpxe_k$(this, get, modify);
}
var MutableReactiveClass;
function MutableReactive() {
  if (MutableReactiveClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'MutableReactive', VOID, VOID, [Reactive()], [1]);
    MutableReactiveClass = $;
  }
  return MutableReactiveClass;
}
function get_state() {
  return _ReactiveState___init__impl__fvdp9b(this.get_value_j01efc_k$());
}
var ReactiveValueClass;
function ReactiveValue() {
  if (ReactiveValueClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ReactiveValue', VOID, VOID, [Reactive()]);
    ReactiveValueClass = $;
  }
  return ReactiveValueClass;
}
function Listenable$Never$NOOP_RELEASE$lambda() {
  return Unit_instance;
}
var NeverClass;
function Never() {
  if (NeverClass === VOID) {
    class $ {
      constructor() {
        Never_instance = this;
        var tmp = this;
        tmp.NOOP_RELEASE_1 = Listenable$Never$NOOP_RELEASE$lambda;
      }
      addListener_6y9mct_k$(listener) {
        return this.NOOP_RELEASE_1;
      }
    }
    protoOf($).beginUse_omrbby_k$ = beginUse;
    initMetadataForObject($, 'Never', VOID, VOID, [Listenable()]);
    NeverClass = $;
  }
  return NeverClass;
}
var Never_instance;
function Never_getInstance() {
  if (Never_instance === VOID)
    new (Never())();
  return Never_instance;
}
function Listenable$beginUse$lambda() {
  return Unit_instance;
}
function beginUse() {
  return this.addListener_6y9mct_k$(Listenable$beginUse$lambda);
}
var ListenableClass;
function Listenable() {
  if (ListenableClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Listenable');
    ListenableClass = $;
  }
  return ListenableClass;
}
function addAndRunListener(_this__u8e3s4, listener) {
  var release = _this__u8e3s4.addListener_6y9mct_k$(listener);
  listener();
  return release;
}
function valueSet(value) {
  this.set_value_v1vabv_k$(value);
}
function *set(value, $completion) {
  this.set_value_v1vabv_k$(value);
  return Unit_instance;
}
function lens_1(get, set) {
  return SetValueLens().new_com_lightningkite_reactive_lensing_SetValueLens_lhprjj_k$(this, get, set);
}
function lens_2(get, modify) {
  return ModifyValueLens().new_com_lightningkite_reactive_lensing_ModifyValueLens_ce3zc7_k$(this, get, modify);
}
var MutableReactiveValueClass;
function MutableReactiveValue() {
  if (MutableReactiveValueClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'MutableReactiveValue', VOID, VOID, [MutableValue(), ReactiveValue(), MutableReactive()], [1]);
    MutableReactiveValueClass = $;
  }
  return MutableReactiveValueClass;
}
function *set_0(value, $completion) {
  this.valueSet_aujvv6_k$(value);
  return Unit_instance;
}
var MutableValueClass;
function MutableValue() {
  if (MutableValueClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'MutableValue', VOID, VOID, VOID, [1]);
    MutableValueClass = $;
  }
  return MutableValueClass;
}
function MutableReactiveValue$_get_value_$ref_6a9vml(p0) {
  return constructCallableReference(() => p0.get_value_j01efc_k$(), 0, 0, 8, VOID, [p0]);
}
function MutableReactiveValue$_set_value_$ref_n0kkrz(p0) {
  return constructCallableReference((p0_0) => {
    p0.set_value_v1vabv_k$(p0_0);
    return Unit_instance;
  }, 1, 0, 9, VOID, [p0]);
}
//region block: exports
export {
  beginUse as beginUse146s8dwmfk72s,
  Listenable as Listenable3m4zqvjcbvczy,
  lens_0 as lens2po2j99uxhjgr,
  lens as lens2x0usmj7eco4,
  lens_2 as lens26es9640ifscs,
  lens_1 as lens2e2i845xidu26,
  valueSet as valueSet3cf2hvvu95f3,
  MutableReactiveValue as MutableReactiveValuettf5l2qj6mxh,
  MutableReactive as MutableReactive2qdhhyljdknhy,
  MutableValue as MutableValue2jbqb2a7km3rc,
  get_state as get_state389x218zizu8a,
  ReactiveValue as ReactiveValue37mnzha3zo6xb,
  Reactive as Reactive1jy75v4li6ldv,
  addAndRunListener as addAndRunListener8g331b1wn43q,
  Never_getInstance as Never_getInstance1g83fzxrvq57k,
  Companion_getInstance as Companion_getInstance3bjjjd8igr9ok,
  MutableReactiveValue$_get_value_$ref_6a9vml as MutableReactiveValue$_get_value_$ref_6a9vml34vdn15gbmoj8,
  MutableReactiveValue$_set_value_$ref_n0kkrz as MutableReactiveValue$_set_value_$ref_n0kkrzla8i7c48thns,
  set as set3ct43wkzm94lj,
  set_0 as set1ry2ssh8gkbcc,
};
//endregion

//# sourceMappingURL=coreInterfaces.mjs.map
